// ======================================================================
// FILE:
// src/modules/expense_management/claims/pages/ExpenseClaimListPage.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claim List
// ======================================================================

import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import expenseClaimService
from "../services/expenseClaimService";

// Components (Next Steps)
import ExpenseClaimKpiBar
from "../components/ExpenseClaimKpiBar";

import ExpenseClaimFilterBar
from "../components/ExpenseClaimFilterBar";

import ExpenseClaimsTable
from "../components/ExpenseClaimsTable";

import ExpenseClaimsPagination
from "../components/ExpenseClaimsPagination";

export default function ExpenseClaimListPage() {

  const navigate =
    useNavigate();

  // ==========================================================
  // STATE
  // ==========================================================

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [pagination, setPagination] =
    useState({});

  const [summary, setSummary] =
    useState({});

  const [page, setPage] =
    useState(1);

  const [pageSize, setPageSize] =
    useState(10);

  const [filters, setFilters] =
    useState({});

  const hasFilters =
    Object.keys(filters || {}).length > 0;

  // ==========================================================
  // LOAD
  // ==========================================================

  const load = useCallback(async () => {

    try {

      setLoading(true);

      const result =
        await expenseClaimService
          .listExpenseClaims({

            page,

            per_page: pageSize,

            ...filters,

          });

      setRows(
        result.data || []
      );

      setPagination(
        result.pagination || {}
      );

      setSummary(
        result.summary || {}
      );

    }

    catch (err) {

      console.error(err);

    }

    finally {

      setLoading(false);

    }

  }, [

    page,

    pageSize,

    filters,

  ]);

  // ==========================================================
  // INITIAL LOAD
  // ==========================================================

  useEffect(() => {

    load();

  }, [load]);

  // ==========================================================
  // REFRESH
  // ==========================================================

  function handleRefresh() {

    load();

  }

  // ==========================================================
  // CREATE
  // ==========================================================

  function handleCreate() {

    navigate(
      "/expense-management/claims/create"
    );

  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="container-fluid">

      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}

      <div
        className="card border-0 mb-4"
        style={{

          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",

          borderRadius: 12,

          color: "#fff",

        }}
      >

        <div
          className="
            card-body
            d-flex
            justify-content-between
            align-items-center
          "
        >

          <div>

            <h2 className="mb-1">

              Expense Claims

            </h2>

            <div>

              Manage employee expense
              claims and reimbursements

            </div>

          </div>

          <div>

            <button
              className="
                btn
                btn-light
                me-2
              "
              onClick={
                handleRefresh
              }
            >

              <i className="fas fa-sync-alt me-2" />

              Refresh

            </button>

            <button
              className="
                btn
                btn-outline-light
              "
              onClick={
                handleCreate
              }
            >

              <i className="fas fa-plus me-2" />

              Create Claim

            </button>

          </div>

        </div>

      </div>

      {/* ====================================================== */}
      {/* KPI */}
      {/* ====================================================== */}

      <ExpenseClaimKpiBar

        summary={summary}

      />

      {/* ====================================================== */}
      {/* FILTER */}
      {/* ====================================================== */}

      <ExpenseClaimFilterBar

        filters={filters}

        onApply={(value) => {

          setPage(1);

          setFilters(value);

        }}

      />

      {/* ====================================================== */}
      {/* TABLE */}
      {/* ====================================================== */}

      <ExpenseClaimsTable

        rows={rows}

        loading={loading}

        hasFilters={hasFilters}

      />

      {/* ====================================================== */}
      {/* PAGINATION */}
      {/* ====================================================== */}

      <ExpenseClaimsPagination

        page={page}

        pageSize={pageSize}

        total={
          pagination.total || 0
        }

        onPageChange={
          setPage
        }

        onPageSizeChange={(size) => {

          setPage(1);

          setPageSize(size);

        }}

      />

    </div>

  );

}